import React, { useCallback, useEffect, useState } from 'react';
import InputCheckbox from '../../../StyledComponents/InputCheckbox';

interface QueryFilterProps {
  query: string;
  selected?: boolean;
  loading?: boolean;
  urlSearchParams?: URLSearchParams;
  onFilterUpdate: (query: string) => void;
}

const QueryFilter = ({
  query,
  selected,
  loading,
  urlSearchParams,
  onFilterUpdate,
}: QueryFilterProps) => {
  const [_selected, setSelected] = useState(selected);

  useEffect(() => {
    if (!loading) {
      setSelected(false);
    }
  }, [loading]);

  const onClick = useCallback(() => {
    const nextQuery = new URLSearchParams(urlSearchParams);
    if (selected) {
      nextQuery.delete('query');
    } else {
      nextQuery.set('query', query);
    }

    setSelected(!selected);
    onFilterUpdate(nextQuery.toString());
  }, [query, selected, urlSearchParams]);

  return (
    <InputCheckbox id="query-checkbox" onChange={() => onClick()} checked={_selected || selected}>
      &quot;{query}&quot;
    </InputCheckbox>
  );
};

export default QueryFilter;
